import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.f6q_1 = partyId;
        this.g6q_1 = pinId;
        this.h6q_1 = icon;
        this.i6q_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.f6q_1.toString() + ', pinId=' + this.g6q_1.toString() + ', icon=' + this.h6q_1 + ', name=' + this.i6q_1 + ')';
      }
      hashCode() {
        var result = this.f6q_1.hashCode();
        result = imul(result, 31) + this.g6q_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.h6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.f6q_1.equals(other.f6q_1))
          return false;
        if (!this.g6q_1.equals(other.g6q_1))
          return false;
        if (!(this.h6q_1 === other.h6q_1))
          return false;
        if (!(this.i6q_1 === other.i6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
